import styled from 'styled-components';

import { mediaTiny } from '@xing-com/layout-tokens';
import { spaceL, spaceS, xdlColorTextSecondary } from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

export const StyledLi = styled.li`
  list-style: none;

  &:not(:last-child) {
    margin-bottom: ${spaceL};
  }
`;

export const StyledHeadline = styled(Headline)`
  flex: 1;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
  margin-bottom: ${spaceS};
  margin-top: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledContainer = styled.div`
  margin-bottom: ${spaceL};
  position: relative;
`;

export const StyledHeadlineContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;

  @media ${mediaTiny} {
    align-items: start;
    flex-direction: column;
    justify-content: inherit;
  }
`;

export const StyledLevelDescription = styled(BodyCopy)`
  color: ${xdlColorTextSecondary};
  flex-shrink: 0;
  margin-bottom: ${spaceS};
  text-align: right;
  white-space: nowrap;
`;
